import * as C from '../common';

export default (values, nodeSlugs) => {
  let output = [C.attachments];

  return [[{ name: `content`, label: `Attachments`, input: output }]];
};
